import React, { useState } from 'react';
import { func, shape, string } from 'prop-types';
import { Redirect, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { Auth } from 'aws-amplify';
import { enqueueSnackbar } from '../../actions/applicationMessageActions';

import Paper from '@material-ui/core/Paper';

import TermsConditions from '../../components/Terms/TermsAndConditions';

import ForgotPasswordForm from './ForgotPasswordForm';
import ResetPasswordForm from './ResetPasswordForm';

import { getError } from '../../helpers/awsErrorMessages';

import clsx from 'clsx';
import classes from './AuthCore.module.css';

const ForgotPassword = ({
    enqueueSnackbar,
    forgotPassword,
    forgotPasswordSubmit,
    location
}) => {
    const params = new URLSearchParams(location.search);
    const [email, setEmail] = useState(
        (params.get('email') || '').toLowerCase()
    );
    const [tocModalOpen, setTocModalOpen] = useState(false);
    const [redirectTo, setRedirectTo] = useState();

    const handleForgottenPassword = async (values, actions) => {
        actions.setSubmitting(true);
        const lowerCaseEmail = values.email.toLowerCase();

        try {
            await forgotPassword(lowerCaseEmail);
            setEmail(lowerCaseEmail);
        } catch (error) {
            const errorMessage = getError(error);
            enqueueSnackbar(errorMessage, 'error');
        } finally {
            actions.setSubmitting(false);
        }
    };

    const handlePasswordReset = async (values, actions) => {
        actions.setSubmitting(true);

        try {
            await forgotPasswordSubmit(
                email,
                values.code,
                values.password
            );

            enqueueSnackbar('Password reset successfully.', 'success');

            setTimeout(() => {
                setRedirectTo({
                    pathname: '/signin'
                });
            }, 2000);
        } catch (error) {
            const errorMessage = getError(error);
            enqueueSnackbar(errorMessage, 'error');
        } finally {
            actions.setSubmitting(false);
        }
    };

    const redirectToSignIn = event => {
        setRedirectTo({
            pathname: '/signIn'
        });
    };

    if (redirectTo) {
        return (
            <Redirect push to={redirectTo} />
        );
    }

    let form = null;

    if (email) {
        form = (
            <ResetPasswordForm
                onSubmit={handlePasswordReset}
            />
        );
    } else {
        form = (
            <ForgotPasswordForm
                onSubmit={handleForgottenPassword}
            />
        );
    }

    return (
        <div className={classes.AuthCore}>
            <Paper className={classes.AuthCoreContainer}>
                <div className={classes.AuthCoreHeroContainer} />
                <div className={clsx(classes.AuthCoreFormContainer, classes.AuthCoreFormContainerOverride)}>
                    <div className={classes.AuthCoreHeader}>
                        <button onClick={redirectToSignIn} type="button">
                            <img
                                alt=""
                                src="/assets/images/backButtonColorIcon.svg"
                            />
                            Back to Sign In
                        </button>
                        <img
                            alt="BOB Logo"
                            className={classes.BOBLogoHeader}
                            src="/assets/images/BOB-BLACK.png"
                        />
                    </div>
                    {form}
                    <div className={classes.termsAndConditionsContainer}>
                        <button
                            className={classes.tocButton}
                            onClick={() => setTocModalOpen(true)}
                        >
                            Terms and Conditions
                        </button>
                    </div>
                    <TermsConditions
                        open={tocModalOpen}
                        handleClose={() => setTocModalOpen(false)}
                    />
                </div>
            </Paper>
        </div>
    );
};

ForgotPassword.defaultProps = {
    enqueueSnackbar,
    forgotPassword:       Auth.forgotPassword.bind(Auth),
    forgotPasswordSubmit: Auth.forgotPasswordSubmit.bind(Auth)
};

ForgotPassword.propTypes = {
    enqueueSnackbar:      func,
    forgotPassword:       func,
    forgotPasswordSubmit: func,
    location:             shape({
        search: string
    })
};

const mapDispatchToProps = {
    enqueueSnackbar
};

export default withRouter(connect(null, mapDispatchToProps)(ForgotPassword));
